export const companyInfo = {
  name: "NR. GALTEN VOGNMANDSFORRETNING ApS",
  cvr: "30575334",
  phone: "21 62 94 36",
  email: "psg@elromail.dk",
  address: "Erslevvej 45, 8370 Hadsten",
  logo: "https://assets.auxodev.dk/assets/bbd899f1-874b-429b-b5f9-77a2b21d61ba/1bf8ce2d-291e-4ca8-b7a4-98511f9c0ee1.png"
};

export const navigation = [
  { name: "Transport med salg og levering", href: "/transport" },
  { name: "Jordflytning", href: "/jordflytning" },
  { name: "Lej en container", href: "/lej-en-container" },
  { name: "Om os", href: "/om-os" },
  { name: "Kontakt", href: "/kontakt" },
];

export const services = [
  {
    id: "transport",
    title: "Transport med salg og levering",
    description: "Vi leverer træpiller, barkflis, træflis, sand, grus, alle slags sten og muld. Vi kan krane det direkte ind i haven med stor præcision.",
    icon: "Truck",
    href: "/transport",
    image: "https://assets.auxodev.dk/assets/bbd899f1-874b-429b-b5f9-77a2b21d61ba/11d8ac04-b4a2-4792-97df-3ed8383a3251.jpg"
  },
  {
    id: "jordflytning",
    title: "Jordflytning",
    description: "Vi har speciale inden for jordflytning og kan håndtere alle lovpligtige anmeldelser af jorden. Vi flytter også jord effektivt med grab.",
    icon: "Navigation",
    href: "/jordflytning",
    image: "https://assets.auxodev.dk/assets/bbd899f1-874b-429b-b5f9-77a2b21d61ba/52ad64ed-5451-45d9-a7a2-f3d8148f1648.jpg"
  },
  {
    id: "container",
    title: "Lej en container",
    description: "Stilling af containere til nedrivningsopgaver, farligt affald, haveaffald osv. Vi leverer, afhenter og bortskaffer affaldet korrekt efter aftale.",
    icon: "Box",
    href: "/lej-en-container",
    image: "https://assets.auxodev.dk/assets/bbd899f1-874b-429b-b5f9-77a2b21d61ba/3f933ef5-2341-4c5f-900c-41539c75ec1f.jpg"
  }
];

export const whyChooseUs = [
  {
    title: "20 års erfaring",
    description: "20 års erfaring i branchen sikrer dig den bedste rådgivning og professionel udførelse.",
    icon: "Award"
  },
  {
    title: "Fleksibilitet",
    description: "Vi tilpasser os dine behov og finder altid den mest optimale løsning.",
    icon: "Zap"
  },
  {
    title: "Pålidelig levering",
    description: "Vi overholder aftalte betingelser og leveringstider, så du trygt kan stole på os.",
    icon: "Clock"
  },
  {
    title: "Lokal forankring",
    description: "Vi kender lokalområdet ud og ind, har 3 ansatte og kører lokalt med vores to biler.",
    icon: "MapPin"
  }
];
